<template>
  <div class="tank-dist-item" :id="'tank_' + data.id">
    <HeadedContainer padded>
      <template v-slot:header>
        {{ $ml.get(`Tank`) }} {{ data.name }}
      </template>

      <template v-slot:header-content>
        <Alerts v-if="hasAlerts" :data="data"/>
      </template>

      <div class="body">

        <TipContainer :data="data" v-if="showTip"/>

        <div class="first section">
          <div class="col-item">
            <app-text-input
              v-model="data.volume"
              @input="onDataUpdate"
              type="number"
              :label="$ml.get(`Tank volume`)"
              min="0"
              max="10000"
              required
              hint="L"
              :digits-after-dot="0"
              :step="1"
            />
          </div>
          <div
            class="col-item"
            :class="{ 'is-proportional': program.fertigation === 'proportional' }"
          >
            <template v-if="program.fertigation === 'proportional'">
              <app-text-input
                :value="filterInjection(data.injection_ratio)"
                @input="onInjectionUpdate"
                type="number"
                min="0.1"
                :label="$ml.get('Injection ratio')"
                :digits-after-dot="1"
              />
              <app-sel
                :items="units"
                v-model="unit"
                label-name="key"
                styling="inline"
              >
                <template v-slot="{ items }">
                  <app-sel-opt
                    v-for="item in items"
                    :value="item"
                  >
                    {{ item.key }}
                  </app-sel-opt>
                </template>
              </app-sel>
            </template>
            <app-text-input
              v-else
              v-model="data.applications"
              @input="onApplicationUpdate"
              type="number"
              min="1"
              :label="$ml.get(`Applications`)"
            />
          </div>
        </div>

        <div class="second section">
          <div class="col-item">
            <div class="label">
              {{ $ml.get(`Water`) }}
            </div>
            <div class="value">
              <!-- {{ data.tank.Water.toFixed(3) }} -->
              {{$store.getters['unit/convert']('L', data.tank.Water)}}
            </div>
          </div>
          <div class="col-item">
            <div class="label">
              {{ $ml.get(`Liquid Fertilizer`) }}
            </div>
            <div class="value">
              {{ data.tank.LiquidFerts > 0 ? data.tank.LiquidFerts : 0 }}
            </div>
          </div>
        </div>
        <div class="table section">

          <div class="row head">
            <div class="col">
              {{ $ml.get(`Fertilizer`) }}
            </div>
            <div class="col">
              {{ $ml.get(`Amount`) }}
            </div>
          </div>

          <div class="row" v-for="item in data.tank.Fertilizers.Fertilizer">
              <div class="col">
                  {{ $ml.get(item.Name) }}

              </div>
            <div class="col">
              <!-- {{ parseFloat(item.VolumeMass).toFixed(2) }} kg -->
              {{$store.getters['unit/convert']('kg', item.VolumeMass)}} {{ $store.getters['unit/getLabel'](item.Unit.toLowerCase()) }}
            </div>
          </div>

        </div>

        <div v-if="!data.tank.Fertilizers.Fertilizer.length" class="empty-fertilizers">
          {{$ml.get('No fertilizers')}}
        </div>
      </div>
    </HeadedContainer>
  </div>
</template>

<script>
import Alerts from './Alerts'
import HeadedContainer from '@/components/common/HeadedContainer'
import TipContainer from './TipContainer'
import { mapGetters } from 'vuex';

export default {
  props: {
    data: {},
  },
  created() {

    // needed for right changing of units DO NOT USE WATCH
    this._last_unit = this.unit;
  },
  methods: {
    onDataUpdate() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.data.volume <=5) this.data.volume = 6;
        this.$store.dispatch('program/fertigation/updateTank', this.data.id);
      }, 1500);
    },


    onApplicationUpdate() {
      clearTimeout(this.applications_timer);
      this.applications_timer = setTimeout(() => {
        this.$store.dispatch('program/fertigation/updateTankWithApplication', this.data.id);
      }, 500);
    },


    filterInjection(val) {


      return parseFloat(this.unitsFilter('L/m³', this.unit, val)).toFixedGentle(2);
    },


    onInjectionUpdate(val) {
      this.data.injection_ratio = this.unitsFilter(this.unit, 'L/m³', val);
      this.onDataUpdate();
    },


    unitsFilter(from, to, val) {
      if(from == 'L/m³' && to == '%') {
        val /= 10;
      }
      else if(from == '%' && to == 'L/m³') {
        val *= 10;
      }
      else if(from == '%' && to == 'gal/1000') {
        val *= 10;
      }
      else if(from == 'gal/1000' && to == '%') {
        val /= 10;
      }
      return val;
    }
  },
  data() {
    return {
      timer: null,
      unit: 'L/m³',
      units: [
        {
          key: 'L/m³',
        },
        {
          key: '%',
        },
        {
          key: 'gal/1000',
        },
      ]
    }
  },
  components: {
    HeadedContainer,
    Alerts,
    TipContainer,
  },
  computed: {
    ...mapGetters({
      program: 'program/data'
    }),

    showTip() {
      return this.program.fertigation === 'quantitative';
    },

    hasAlerts() {
      return !!(
        (
          this.data.tank.ErrorAlerts &&
          this.data.tank.ErrorAlerts.length
        ) || (
          this.data.tank.FriendlyAlerts &&
          this.data.tank.FriendlyAlerts.length
        )
      )
    }
  },
}
</script>

<style lang="scss" scoped>

.tank-dist-item {

  width: 450px;

  .headed-container {
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  }

  .body {

    display: flex;
    flex-direction: column;

    .col-item {
      width: 50%;

      display: flex;
      flex-direction: row;
      align-items: stretch;
    }

    .section {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .first {
      padding-top: 20px;
      .col-item {
        padding-right: 30px;
        &.is-proportional {
          padding-right: 0;

          .app-sel {
            width: 100%;
          }

          .app-text-input {
            min-width: 95px;
          }
        }
      }
    }

    .second {
      font-size: 16px;
      padding-bottom: 30px;
      padding-top: 30px;

      .col-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding-right: 30px;

        &:last-child {
          padding-right: 0;

          .value {
            max-width: 75px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }

      .label {

      }
      .value {
        font-weight: bold;
      }
    }

    .table {
      font-size: 16px;

      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .row {
        width: 100%;
        display: flex;
        flex-direction: row;

        .col {
          color: #4C5056;
          padding: 20px 0;
          width: 50%;
        }

        &.head {
          .col {
            color: #000;
            font-weight: bold;
            border-bottom: 1px solid #E4E5E6;
            padding: 20px 0;
          }
        }
      }
    }
  }


  @media (max-width:768px) {
    width: 100%;
    margin-right: 0!important;
    .headed-container {
      .body {
        margin-top: 0px;
        width: 100%;
        padding: 8px;
        .first, .second {
          flex-direction: column;
          align-items: flex-start;
          padding-top: 0;
          .col-item {
            width: 100%;
            padding: 0;
            margin-top: 32px;
          }
        }
        .table {
          .row {
            width: 100%;
            justify-content: space-between;
            .col {
              width: auto;
            }
            &.head {
              border-bottom: 1px solid #E4E5E6;
              .col {
                border-bottom: none;
              }
            }
          }
        }
      }
    }

  }
}

</style>
